<template>
  <tr>
    <td><DataCell type="date" :value="message.timestamp" /></td>
    <td v-if="expand">
      <button @click="toggleMessage">...</button>
      <code>{{ JSON.stringify(message.content, null, 2) }}</code>
    </td>
    <td v-else>
      <button @click="toggleMessage">raw</button>
      {{ this.previewMessage }}
    </td>
  </tr>
</template>

<script>
import DataCell from '@/components/DataCell.vue'

export default {
  name: 'Message',
  props: ['message'],
  data() {
    return {
      expand: false
    }
  },
  computed: {
    previewMessage: function() {
      if (
        typeof this.message.content === 'object' &&
        'message' in this.message.content
      )
        return this.message.content.message
      return this.message.content
    }
  },
  methods: {
    toggleMessage() {
      this.expand = !this.expand
    }
  },
  components: {
    DataCell
  }
}
</script>

<style scoped>
td:first-child {
  font-size: 80%;
  text-align: right;
  padding-right: 4px;
  border-right: 1px solid #ddd;
}
</style>
